import {Card, Stack, Table, Title} from '@mantine/core';
import {Pipeline} from '../types';

export const DeploymentAccountsPanel = ({record}: { record: Pipeline }) => {

    if (!record.deploymentAccounts || record.deploymentAccounts.length === 0) {
        return null;
    }

    return (
        <Card withBorder padding='md' radius='md'>
            <Stack gap={'sm'}>
                <Title order={5}>Deployment Accounts</Title>
                <Table striped highlightOnHover withTableBorder>
                    <Table.Thead>
                        <Table.Tr>
                            <Table.Th>Account ID</Table.Th>
                            <Table.Th>Account Name</Table.Th>
                            <Table.Th>Region</Table.Th>
                        </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                        {record.deploymentAccounts.map((account, index) => (
                            <Table.Tr key={index}>
                                <Table.Td>{account.accountId}</Table.Td>
                                <Table.Td>{account.accountName || 'n/a'}</Table.Td>
                                <Table.Td>{account.region || 'n/a'}</Table.Td>
                            </Table.Tr>
                        ))}
                    </Table.Tbody>
                </Table>
            </Stack>
        </Card>
    );
};
